import React, { useState } from 'react';
import NewApplicationHOC from '../../containers/newApplicationHOC'
import OverviewTabHOC from '../../containers/ApplicationTabs/overviewTabHOC';
import PolicyTabHOC from "../../containers/policyTabHOC";
import DocumentsTabHOC from '../../containers/ApplicationTabs/documentsTabHOC'
import UpdateTabHOC from '../../containers/ApplicationTabs/updateTabHOC';
import moment from "moment/moment";
import AdvancedDisbursementsTabHOC from "../../containers/ApplicationTabs/advancedDisbursementsTabHOC";
import FinancialsTabHOC from "../../containers/ApplicationTabs/financialsTabHOC";
import PendingChangesTabHOC from "../../containers/ApplicationTabs/pendingChangesTabHOC";
import { Link, Popover, Button, Alert, FormGroup } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import {
    LEFT,
    MOMENT_DATE_TIME_FORMAT,
    PRIMARY,
    TERTIARY,
    SOLICITOR,
    REJECTED_OR_DECLINED_STATUSES,
    DOWNLOAD,
    PREVIEW,
    ERROR,
    TAB_APPLICATION,
    TAB_OVERVIEW,
    TAB_DOCUMENTS,
    TAB_UPDATE,
    TAB_POLICY_SCHEDULE,
    TAB_FINANCIALS,
    TAB_ADVANCED_DISBURSEMENTS,
    TAB_PENDING_CHANGES,
} from '../../helpers/constants';
import { isGatewayPlutusLawsys } from '../../helpers/functions';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import style from '../../style/general.css';
import { isPreviewable } from '../General/FilePreview';
import EditIcon from '../icons/editIcon';
import ModalWrapper from '../../helpers/modalWrapper';

const ApplicationPolicyPageContent = (props) => {

    const {
        Store,
        User,
        SelectedApp,
        CheckUserOverviewTabCheckBox,
        PageShift,
        ChangeOverViewTabReadMoreState,
        requestApplicationAttachment,
        openFilePreview,
        SavedApplicationAttachments,
        openRenameAttachmentModal,
        closeRenameAttachmentModal,
        requestRenameAttachment,
        RequestDeleteDocument,
        isArag,
        _openAdvancedDisbursementsApplicationModal,
        newApplication,
        match,
        router,
        advanceDisbursementsEnabled
    } = props;


    const [openPopoverId, setOpenPopoverId] = useState(null);
    const [newName, setNewName] = useState('');
    const [localNameError, setLocalNameError] = useState('');
    const isRejectedOrDeclined = REJECTED_OR_DECLINED_STATUSES.includes(SelectedApp.policyStatusMachineName);
    const showFinancials = isGatewayPlutusLawsys(SelectedApp.systemsOfRecordId) && isArag;
    const { renameModalOpen, attachmentForRename, renaming, renameError } = Store;

    // reducers/applicationPolicy.js's LOCATION_CHANGE case deliberately preserves activeTab across route
    // changes that stay within the policy area, so it can survive into a policy where the previously
    // active tab no longer applies (Financials is per-policy/SoR-dependent, Advanced Disbursements is a
    // per-tenant feature flag). Every branch below is `activeTab === X ? <Tab/> : null`, so without a
    // default case, an unavailable activeTab matches nothing at all and the body renders blank. Falling
    // back to the Application tab here - purely for this render, no dispatch needed - is enough: the
    // render is derived fresh from props every time, so there's nothing to "get stuck" once the tab
    // becomes available again on a later policy.
    const isFinancialsTabActive = Store.activeTab === TAB_FINANCIALS && showFinancials;
    const isAdvancedDisbursementsTabActive = Store.activeTab === TAB_ADVANCED_DISBURSEMENTS && advanceDisbursementsEnabled;
    const isKnownActiveTab = [
        TAB_OVERVIEW, TAB_DOCUMENTS, TAB_UPDATE, TAB_POLICY_SCHEDULE, TAB_PENDING_CHANGES
    ].includes(Store.activeTab) || isFinancialsTabActive || isAdvancedDisbursementsTabActive;

    const getNameWithoutExtension = (filename) => {
        const lastDot = filename.lastIndexOf('.');
        return lastDot > 0 ? filename.substring(0, lastDot) : filename;
    };

    const getExtension = (filename) => {
        const lastDot = filename.lastIndexOf('.');
        return lastDot > 0 ? filename.substring(lastDot) : '';
    };

    const handleOpenRenameModal = (attachment) => {
        setNewName(getNameWithoutExtension(attachment.name));
        setLocalNameError('');
        openRenameAttachmentModal(attachment);
    };

    const handleCloseRenameModal = () => {
        setNewName('');
        setLocalNameError('');
        closeRenameAttachmentModal();
    };

    const handleRenameSubmit = () => {
        if (!newName.trim()) {
            setLocalNameError(CONTENT_STRINGS.NAME_CANNOT_BE_EMPTY);
            return;
        }
        setLocalNameError('');
        requestRenameAttachment(
            SelectedApp.id,
            attachmentForRename.id,
            newName.trim(),
            attachmentForRename.relativeUrl
        );
    };
    
    let userRole = User.loggedInUser.roles[0];
    let attachments = [];
    let rowData = [];
    let value;
    let Label;
    let buttons;

    if (SavedApplicationAttachments.length > 0) {
        attachments = SavedApplicationAttachments;
    }

    for (let i = 0; i < attachments.length; i++) {
        const attachment = attachments[i];
        const isPopoverOpen = openPopoverId === attachment.id;
        
        Label = <div>
            <p className="applicationPolicy-paragraph textBold">{attachment.fullName}</p>
            <p className="applicationPolicy-paragraph">{moment(attachment.addedAt).format(MOMENT_DATE_TIME_FORMAT)}</p>
        </div>;
        
        value = attachment.name;
        const canPreview = isPreviewable(attachment.name);
        buttons =
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='document-buttons-container'>
                        {canPreview && (
                            <Button
                                key={`preview-${i}`}
                                className={'document-preview-button'}
                                variant={PREVIEW}
                                label={CONTENT_STRINGS.PREVIEW}
                                onClick={() => {
                                    openFilePreview(attachment);
                                    !attachment.encodedFile && requestApplicationAttachment({
                                        applicationId: SelectedApp.id,
                                        attachmentId: attachment.id,
                                        relativeUrl: attachment.relativeUrl
                                    });
                                }}
                                buttonTestId={`document-${i}-preview`}
                            />
                        )}
                        <Button
                            key={`download-${i}`}
                            variant={DOWNLOAD}
                            label={CONTENT_STRINGS.DOWNLOAD}
                            onClick={() => { requestApplicationAttachment({
                                applicationId: SelectedApp.id,
                                attachmentId: attachment.id,
                                relativeUrl: attachment.relativeUrl
                            }); }}
                            buttonTestId={`document-${i}-download`}
                        />
                        {(isArag && !isRejectedOrDeclined) && (
                            <EditIcon
                                onClick={() => handleOpenRenameModal(attachment)}
                                editIconTestId={`document-${i}-rename`}
                            />
                        )}
                        {(userRole !== SOLICITOR && !isRejectedOrDeclined) && (
                            <div className='document-delete-container'>
                                <Link
                                    label={CONTENT_STRINGS.DELETE}
                                    variant={TERTIARY}
                                    arrowDirection={LEFT}
                                    onClick={() => { setOpenPopoverId(attachment.id); }}
                                    linkTestId={`document-${i}-delete`}
                                />
                                { isPopoverOpen &&
                                    <Popover
                                        popover={{
                                            title: CONTENT_STRINGS.ARE_YOU_SURE,
                                            content:
                                                <Button
                                                    variant={PRIMARY}
                                                    label={CONTENT_STRINGS.YES}
                                                    onClick={() => {
                                                        RequestDeleteDocument(SelectedApp.id, attachment.id, attachment.relativeUrl);
                                                        setOpenPopoverId(null);
                                                    }}
                                                    buttonTestId={`document-${i}-popover-yes`}
                                                />
                                            ,
                                            closeLabel: CONTENT_STRINGS.NO,
                                        }}
                                        onPopoverLeave={() => { setOpenPopoverId(null) }}
                                        popoverId={`document-${i}-popover`}
                                        buttonTestId={`document-${i}-popover-no`}
                                        titleTestId={`document-${i}-popover-message`}
                                    />
                                }
                            </div>
                        )}
                    </div>
                </div>
            </div>;
        
        rowData.push({
            key: Label,
            value: value,
            buttons: buttons,
        });
    }
    return (
        <div className="row">
            {
                // Falls back to the Application tab whenever activeTab isn't one this policy actually
                // offers (see isKnownActiveTab above), not just when it's literally TAB_APPLICATION.
                (Store.activeTab === TAB_APPLICATION || !isKnownActiveTab) ?
                    <div className="col-sm-12">
                        <NewApplicationHOC />
                    </div>
                    :
                    null
            }
            {
                (Store.activeTab === TAB_OVERVIEW) ?
                    <OverviewTabHOC
                        ApplicationPolicyStore={Store}
                        CheckUserOverviewTabCheckBox={CheckUserOverviewTabCheckBox}
                        UserRole={userRole}
                        PageShift={PageShift}
                        ChangeOverViewTabReadMoreState={ChangeOverViewTabReadMoreState}
                        requestApplicationAttachment={requestApplicationAttachment}
                    />
                    :
                    null
            }
            {
                (Store.activeTab === TAB_DOCUMENTS)
                ?
                    <DocumentsTabHOC
                        fetchingAllApplicationAttachments={newApplication.fetchingAllApplicationAttachments}
                        rowData={rowData}
                    />
                :
                    null
            }
            {
                (Store.activeTab === TAB_UPDATE) ?
                    <UpdateTabHOC />
                    :
                    null
            }
            {
                (Store.activeTab === TAB_POLICY_SCHEDULE) ?
                    <PolicyTabHOC
                        match={match}
                        router={router}
                        selectedApp={SelectedApp}
                    />
                    :
                    null
            }
            {
                // Financials tab (gATEway-PLUTUS-Lawsys policies only - see policyTabs.js's showFinancials
                // gate). No props needed here: FinancialsTabHOC reads applicationId from redux state itself
                // and fetches on mount, same as the other tab HOCs below it.
                isFinancialsTabActive ?
                    <FinancialsTabHOC />
                    :
                    null
            }
            {
                isAdvancedDisbursementsTabActive ?
                    <AdvancedDisbursementsTabHOC
                        _openAdvancedDisbursementsApplicationModal={_openAdvancedDisbursementsApplicationModal}
                        User={User}
                    />
                    :
                    null
            }
            {Store.activeTab === TAB_PENDING_CHANGES && (<PendingChangesTabHOC/>)}
            <ModalWrapper
                isOpen={renameModalOpen}
                onClose={handleCloseRenameModal}
                buttonTestId={"rename-attachment-close"}
                modalTestId={"rename-attachment-modal"}
                title={CONTENT_STRINGS.RENAME_DOCUMENT}
            >
                {attachmentForRename
                ?
                    <div className="form-horizontal">
                        <FormGroup
                            labelSize={"col-sm-3"}
                            inputSize={"col-sm-6"}
                            variant={FORM_GROUP_VARIANTS.TEXT}
                            label={CONTENT_STRINGS.NAME}
                            inputProps={{
                                id: 'attachmentName',
                                name: 'attachmentName',
                                value: newName,
                                onChange: (e) => setNewName(e.target.value),
                                disabled: renaming,
                            }}
                            hasInlineElements
                            inlineGroupElements={
                                <div className={'col-sm-3'} style={{ marginTop: '7px' }}>
                                    {getExtension(attachmentForRename.name)}
                                </div>
                            }
                            formGroupTestId={'rename-attachment-input'}
                        />
                        {(localNameError || renameError) 
                        ?
                            <div className="form-group">
                                <div className="col-sm-offset-3 col-sm-7">
                                    <Alert label={localNameError || renameError} variant={ERROR} />
                                </div>
                            </div>
                        :
                            null
                        }
                        <div className="form-group">
                            <div className="col-sm-offset-3 col-sm-7">
                                <Button
                                    variant={PRIMARY}
                                    label={CONTENT_STRINGS.SAVE}
                                    onClick={handleRenameSubmit}
                                    buttonTestId={"rename-attachment-save"}
                                    disabled={renaming}
                                />
                            </div>
                        </div>
                    </div>
                : 
                    null
                }
            </ModalWrapper>
        </div>
    )
};

export default ApplicationPolicyPageContent;